import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import * as _ from "lodash";
import classnames from "classnames";
import style from "./style";

// Create styles
const useStyles = makeStyles(() => createStyles(style()));

// Props type
type props = {
  note: string;
  errorMessage: string;
};

// UIErrorOrNoteMessage Component
export const UIErrorOrNoteMessage = (props: props): React.JSX.Element => {
  const { errorMessage, note } = props;
  const classes = useStyles();

  if (_.isEqual(errorMessage.length, 0)) {
    return (
      <div
        className={classnames(classes.note, {
          [classes.noteErrorMargin]: !_.isEmpty(note),
        })}
        dangerouslySetInnerHTML={{
          __html: note,
        }}
      ></div>
    );
  }
  return (
    <div
      className={classnames(classes.error, {
        [classes.noteErrorMargin]: !_.isEmpty(errorMessage),
      })}
    >
      {errorMessage}
    </div>
  );
};
